import { render, staticRenderFns } from "./teacherPage.vue?vue&type=template&id=0b1a7ea4&scoped=true"
import script from "./teacherPage.vue?vue&type=script&lang=js"
export * from "./teacherPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a7ea4",
  null
  
)

export default component.exports